import { render, staticRenderFns } from "./Grid.global.vue?vue&type=template&id=5ff93de7&scoped=true&lang=pug&"
import script from "./Grid.global.vue?vue&type=script&lang=ts&"
export * from "./Grid.global.vue?vue&type=script&lang=ts&"
import style0 from "./Grid.global.vue?vue&type=style&index=0&id=5ff93de7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff93de7",
  null
  
)

export default component.exports